import { Controller } from "@hotwired/stimulus";

// Step `payment` del wizard de onboarding. Coordina:
//   - Switch de país en el select (askCountryId) → toggle visible entre wrap
//     Stripe y wrap Transbank, y actualiza los hidden `country_id`/`gateway`.
//   - Submit del form → si gateway=transbank, deja submit nativo (Webpay).
//     Si gateway=stripe, busca el controller `stripe-card-form` montado en
//     el `stripeWrap` y le pide tokenizar antes de `requestSubmit()`.
//
// El montaje de Stripe Elements + tokenización en sí vive en el Stimulus
// shared `stripe-card-form` (registrado en el `stripeWrap` desde la vista).
export default class extends Controller {
  static values = {
    isCl: Boolean,
  };

  static targets = [
    "form",
    "submitButton",
    "stripeWrap",
    "transbankWrap",
    "countrySelect",
    "countryInput",
    "gatewayInput",
  ];

  switchCountry(event) {
    const country = event.target.value;
    const isCl = country === "CL";
    if (this.hasCountryInputTarget) this.countryInputTarget.value = country;
    if (this.hasGatewayInputTarget) this.gatewayInputTarget.value = isCl ? "transbank" : "stripe";
    this.stripeWrapTarget.classList.toggle("hidden", isCl);
    this.transbankWrapTarget.classList.toggle("hidden", !isCl);
  }

  async submit(event) {
    const gateway = this.gatewayInputTarget.value;
    if (gateway === "transbank") return; // submit nativo del form

    event.preventDefault();
    event.stopPropagation();

    const stripeController = this.application.getControllerForElementAndIdentifier(
      this.stripeWrapTarget,
      "stripe-card-form"
    );

    if (!stripeController) {
      alert("Stripe no está inicializado. Recarga la página.");
      return;
    }

    this.setLoading(true);
    const ok = await stripeController.tokenize();
    if (!ok) {
      this.setLoading(false);
      return;
    }

    // El backend redirige a :permalink.flycrew.com (otro origin que el host del
    // onboarding). Con Turbo, el submit se sigue por fetch cross-origin con
    // credentials:"same-origin" y la cookie de sesion NO viaja -> el usuario cae
    // deslogueado en el subdominio y termina en flycrew.com/experiences (404).
    // Forzamos navegacion top-level (data-turbo=false) para que el navegador
    // siga el redirect de verdad y la cookie .flycrew.com cruce al subdominio.
    this.formTarget.setAttribute("data-turbo", "false");
    this.formTarget.requestSubmit();
  }

  setLoading(loading) {
    if (!this.hasSubmitButtonTarget) return;
    this.submitButtonTarget.disabled = loading;
  }
}
